import { type FC } from "react";

import { mapSequenceTypeToEntityType } from "../../../../app-utils/route.js";
import { type Sequence } from "../../../../graphql.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { traverseAndCollect } from "../column-props-factory.js";
import { SummaryPageLink } from "./core/LinkCell.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";

const SequenceLinkCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const { data, colDef } = props;
  const value = traverseAndCollect(data, colDef.groupField);
  const multiValues: Sequence[] = Array.isArray(value) ? value : [value];

  if (!multiValues.length) {
    return null;
  }
  const items: ListCellItem[] = multiValues.map((value: Sequence) => {
    return {
      value: (
        <SummaryPageLink
          linkLabel={value.sequenceId}
          entityGroupType={mapSequenceTypeToEntityType(value.sequenceGroup.name)}
          entityId={value.id}
        />
      ),
    };
  });

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export { SequenceLinkCell };
